import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=0a1a651f&scoped=true&lang=pug&"
import script from "./NavMenuItem.vue?vue&type=script&lang=coffee&"
export * from "./NavMenuItem.vue?vue&type=script&lang=coffee&"
import style0 from "./NavMenuItem.vue?vue&type=style&index=0&id=0a1a651f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1a651f",
  null
  
)

component.options.__file = "NavMenuItem.vue"
export default component.exports